export const returnLeaveDays = (dates: string[]) =>
  dates?.length > 0
    ? dates
        .map((date: string) => date.slice(5).split('-').reverse().join('-'))
        .join(', ')
    : '-';
